import { render, staticRenderFns } from "./metadata.vue?vue&type=template&id=4a0024f4&scoped=true"
import script from "./metadata.vue?vue&type=script&lang=js"
export * from "./metadata.vue?vue&type=script&lang=js"
import style0 from "./metadata.vue?vue&type=style&index=0&id=4a0024f4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0024f4",
  null
  
)

export default component.exports